export default __webpack_public_path__ + "static/media/IMG_1288.a5376edd.jpg";